<ng-container [formGroup]="formGroup">
  <ng-container [formGroupName]="blockFormName">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <app-form-render-label [item]="item"></app-form-render-label>
            <input type="hidden" [formControlName]="item.key" [value]="avis_obj">
            <mat-radio-group style="display:block;margin-top: 10px;">
              <ng-container *ngFor="let option of item.options.options.avis; let i = index">
                <mat-radio-button [value]="option.key" class="item"
                                  [class.horizontal]="true" [disabled]="!mode_sollicite" (change)="setAvisValue($event)">
                  {{option.key}}
                </mat-radio-button>
              </ng-container>
            </mat-radio-group>
          </div>
          &nbsp;
          <div fxLayout="column" *ngIf="!avis_obj?.sollicite?.display_name">
            <app-search-ldap fxFlex="90"
                             [ldapDisplayProperty]="'cn,mail'"
                             [removeDiatrics]="true"
                             [placeHolder]="'Rechercher ici la personne sollicitée à donner son avis'"
                             [scope]="scope"
                             [title]="false"
                             [defaultScopes]="defaultScopes"
                             [scopesToDisplay]="scopesToDisplay"
                             (ldapUserSelected)="onSelectIndiv($event)">
            </app-search-ldap>
          </div>
          <div *ngIf="avis_obj?.sollicite?.display_name" class="indiv_container">
            <span class="con_label">{{avis_obj?.sollicite?.display_name}}</span>
            <span class="con_action">
              <button mat-raised-button type="button"
                      matTooltip="Supprimer la personne sollicitée"
                      (click)="deleteIndiv()" data-cy="btn-suppression-sollicite">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
